import {
  __,
  validateEmail,
  validatePhone,
  containsCyrillic,
} from '../../utilities';

const validate = values => {
  const text = __('Pole je povinné');

  const errors = {};

  if (!values.email) {
    errors.email = text;
  }
  if (!values.login) {
    errors.login = text;
  }
  if (!values.username) {
    errors.username = text;
  } else if (containsCyrillic(values.username)) {
    errors.username = __('Prosím nepoužívajte azbuku');
  }
  if (!values.surname) {
    errors.surname = text;
  } else if (containsCyrillic(values.surname)) {
    errors.surname = __('Prosím nepoužívajte azbuku');
  }
  if (!validateEmail(values.email)) {
    errors.email = __('Nesprávny formát emailu!');
  }
  if (!validatePhone(values.contact)) {
    errors.contact = __('Nesprávny formát mobilného čísla!');
  }
  if (!values.contact) {
    errors.contact = text;
  }
  if (!values.password_client) {
    errors.password_client = text;
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/containers/Login/validate.js